export const props = Object.freeze({
  /**
   * The grouped options to render. Each group has a `text` heading, an optional `description`, and a `children` array of `{ text, value }` options. A childless group that carries its own `value` renders as a single standalone radio-card.
   *
   * @type {Array}
   * @default []
   */
  groups: {
    type: Array,
    default: () => [],
  },
  /**
   * The currently selected option value. Single-select across every group.
   *
   * @type {String|Number}
   * @default undefined
   */
  modelValue: {
    type: [String, Number],
    default: undefined,
  },
  /**
   * The `data-testid` each option carries.
   *
   * @type {String}
   * @default undefined
   */
  optionTestId: {
    type: String,
    default: undefined,
  },
});
